<template>
    <v-dialog content-class="pro-dialog" v-model="forbiddenCriteriaDialog" persistent max-width="600px">
        <v-card>
            <v-card-title>
                <h2 class="headline-title">Informations incompatibles</h2>
            </v-card-title>
            <v-card-text>
                <v-spacer></v-spacer>

                <div v-for="criteria in forbiddenList">
                    Le tarif <b>{{ criteria.label }}</b> est incompatible avec <b>{{ currentElement.label }}.</b>
                </div>

                <v-spacer></v-spacer>

                <div class="d-flex  justify-content-between mt-5">
                    <v-btn class="text-none" color="success" outlined @click="cancelAction">
                        Annuler mon choix
                    </v-btn>

                    <v-btn class="text-none" color="error" outlined @click="deletePrices">
                        Supprimer les tarifs concernés
                    </v-btn>
                </div>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import {mapMutations, mapState} from "vuex"

export default {
    name: "ForbiddenCriteriaModal",
    methods: {
        ...mapMutations('web_form', ['setForbiddenCriteriaDialog', 'removeElement', 'addElement']),
        ...mapMutations('forbiddenCriteria', ['setForbiddenList']),
        cancelAction() {
            if (this.actionType === 'ADD') {
                this.removeElement(this.currentElement)

                // cas élément simple lors d'un ajout, après avoir supprimé le nouvel élément, il faut rajouter l'ancien
                if (this.actionType === 'ADD' && !Array.isArray(this.previousValue)) {
                    this.addElement(this.previousValue)
                }
            } else {
                this.addElement(this.currentElement)
            }

            this.setForbiddenCriteriaDialog(false)
        },
        deletePrices() {
            this.forbiddenList.forEach(element => {
                this.provider.price_periods.forEach(period => {
                    period.prices = period.prices.filter(price => price.element.id !== element.id)

                    element.disabled = false
                })
            })

            this.setForbiddenList([])
            this.setForbiddenCriteriaDialog(false)
        },
    },
    computed: {
        ...mapState("web_form", ['forbiddenCriteriaDialog', 'provider']),
        ...mapState("forbiddenCriteria", ['forbiddenList', 'previousValue', 'currentElement', 'actionType']),
        dialog: {
            get () {
                return this.forbiddenCriteriaDialog
            },
            set (value) {
                this.setForbiddenCriteriaDialog(value)
            }
        }
    }
}
</script>

